import React, { useState } from 'react';
import { includes, propOr } from 'ramda';
import { Button, message, Tabs } from 'antd';
import CcnOfferTypeSettings from './CcnOfferTypeSettings';
import UpdateCcnSettings from '../../../mutations/UpdateCcnSettings';

const CcnSettings = ({
  ccn,
  settings
}) => {
  const [ccnSettings, setCcnSettings] = useState(settings);

  const offerTypes = propOr([], 'offerTypes', ccn);
  const hasOfferType = offerType => includes(offerType, offerTypes);

  const onSave = () => {
    UpdateCcnSettings(ccn.id, ccnSettings, (ok, error) => {
      if (ok && !error) {
        message.success('Les paramètres de la CCN ont bien été mis à jour.');
      } else {
        message.error('Une erreur est survenue.');
      }
    });
  };

  return <div>
    <Tabs>
      {hasOfferType('PREVOYANCE') && <Tabs.TabPane tab="Prévoyance" key="PREVOYANCE">
        <CcnOfferTypeSettings
          offerType="PREVOYANCE"
          settings={propOr({}, 'PREVOYANCE', ccnSettings)}
          setCcnSettings={setCcnSettings}
        />
      </Tabs.TabPane>}

      {hasOfferType('SANTE') && <Tabs.TabPane tab="Santé" key="SANTE">
        <CcnOfferTypeSettings
          offerType="SANTE"
          settings={propOr({}, 'SANTE', ccnSettings)}
          setCcnSettings={setCcnSettings}
        />
      </Tabs.TabPane>}
    </Tabs>

    <Button
      type="primary"
      icon="save"
      onClick={onSave}
      style={{ margin: '20px auto 0 auto', display: 'block' }}
    >
      Enregistrer
    </Button>
  </div>;
};

export default CcnSettings;
